import React from 'react'
import { GridRow } from 'src/components/Reusable/Grid'
import { useRisksContext } from 'src/pages/Risks/context/RisksContext'
import {
  GridColumnSortRiskControls,
  GridColumnSortType,
} from 'src/components/Reusable/Grid/GridColumnSort/GridColumnSort.constants'
import { RiskControlGridColumnSort } from 'src/components/Reusable/Grid/GridColumnSort/RiskGridColumnSort'
import { RISK_CONTROL_HEADERS } from '../risks.constants'
import { StyledRisksGridHeader } from '../risks.styles'

export const RisksControlsGridHeader = (): JSX.Element => {
  const { controlSortType } = useRisksContext()
  return (
    <GridRow>
      {RISK_CONTROL_HEADERS.map((header) => (
        <StyledRisksGridHeader
          key={header.name}
          justifyContent="flex-start"
          $top={0}
        >
          {header.name}
          {header.sortable && (
            <RiskControlGridColumnSort
              type={controlSortType as GridColumnSortType}
              colName={header.name as GridColumnSortRiskControls}
            />
          )}
        </StyledRisksGridHeader>
      ))}
    </GridRow>
  )
}
